import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@syneto/compass-react';
import { upgradeChannelAppearance, upgradeChannelLabel } from '../../helpers/UpgradeChannelFormatter';

const UpgradeChannelBadge = (props) => {
	const { channel } = props;

	return (
		<Badge appearance={upgradeChannelAppearance(channel)}>
			{upgradeChannelLabel(channel)}
		</Badge>
	);
};

UpgradeChannelBadge.propTypes = {
	channel: PropTypes.string
};

export default UpgradeChannelBadge;
